import { Quote } from "lucide-react";
import Reveal from "@/components/Reveal";
import Stars from "@/components/Stars";
import GoogleReviewsPanel from "@/components/GoogleReviewsPanel";
import useSEO from "@/hooks/useSEO";
import { TESTIMONIALS } from "@/data/site";

export default function TestimonialsPage() {
  useSEO("Testimonials");
  return (
    <div data-testid="testimonials-page">
      {/* HERO */}
      <section className="bg-[#050505] pt-16 md:pt-24 pb-20 md:pb-28">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Reveal><p className="cc-eyebrow justify-center mb-6">Testimonials</p></Reveal>
          <Reveal delay={100}>
            <h1 className="font-display font-black uppercase text-4xl sm:text-5xl lg:text-[60px] leading-[1.02] text-white">
              What Our<br />
              Customers <span className="text-[#F28C00]">Say</span>
            </h1>
          </Reveal>
          <Reveal delay={200}>
            <p className="text-[#9A9A9A] text-base sm:text-lg leading-relaxed mt-8 max-w-2xl mx-auto">
              We let our work speak for itself — but we also let our clients. Here's what homeowners and developers across Edinburgh and Central Scotland have said about working with City Civils.
            </p>
          </Reveal>
        </div>
      </section>

      {/* MAIN TESTIMONIALS */}
      <section className="bg-[#0B0B0B] py-24 md:py-32 border-y border-[#181818]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-14">
            <GoogleReviewsPanel rating={5.0} count={9} />
          </div>
          <div className="grid md:grid-cols-2 gap-6 cc-stagger">
            {TESTIMONIALS.map((t, i) => (
              <Reveal key={`${t.name}-${i}`} className="bg-[#111111] border-t-[3px] border-[#F28C00] p-8 lg:p-10 relative" data-testid={`testimonial-card-${i}`}>
                <Quote className="w-12 h-12 text-[#F28C00] mb-6" />
                <p className="text-[#9A9A9A] text-base leading-relaxed mb-8 italic">"{t.text}"</p>
                <div className="flex items-center gap-4 pt-6 border-t border-[#181818]">
                  <img src={t.image} alt={t.name} className="w-14 h-14 rounded-full object-cover ring-2 ring-[#F28C00]/40" />
                  <div className="flex-1">
                    <div className="text-white font-display font-bold uppercase tracking-wider text-sm">{t.name}</div>
                    <div className="text-[#9A9A9A] text-xs mt-1">{t.location}</div>
                    <Stars className="mt-2" />
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
